import Route from "vue-routisan";
import isAuthenticated from "../middlewares/isAuthenticated";
import isManager from "../middlewares/isManager";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";
import userPermission from "@/util/valueObjects/userPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager", beforeEnter: [isAuthenticated, hasIntegraPermission]}, () => {

    Route.group({prefix: "manager", beforeEnter: [isManager]}, () => {

      Route.redirect("/", to => {
        return {name: "manager.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/Dashboard/Dashboard.vue")
      ).name("manager.dashboard");

      Route.view("/integration_monitor", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/Dashboard/IntegrationMonitor.vue")
      ).name("manager.integration_monitor");

      Route.group({prefix: "notification"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/notification/NotificationList.vue")
        ).name("manager.notification");
      })

      Route.view("/control_tower", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/Dashboard/ControlTower.vue")
      ).name("manager.control_tower");

      Route.view("/order_in_progress", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/Dashboard/OrderInProgress.vue")
      ).name("manager.order_in_progress");

      Route.view("/menu", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/Dashboard/PrincipalMenu.vue")
      ).name("manager.menu");

      Route.view("/tms", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/Dashboard/TmsCatalde.vue")
      ).name("manager.menu")
        .options({
          meta: {
            layout: () =>
              import(/* webpackChunkName: "guest" */ "@/resources/views/guest/Layout/EmptyLayout.vue")
          }
        });

      /* --------------------------------------------------------------------------------------------------------------
      |                                               CONFIGURATION                                                   |
      ---------------------------------------------------------------------------------------------------------------*/

      Route.group({prefix: "configuration"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/configuration/Configuration")
        ).name("manager.configuration");
      });

      Route.group({prefix: "users"}, () => {
        /*---------------------------------------------------------------------------------------------------------------
        |                                               USERS                                                          |
        ---------------------------------------------------------------------------------------------------------------*/
        Route.group({prefix: "user"}, () => {
          Route.view("/", () =>
            import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/user/UserList")
          ).name("manager.user");
          Route.view("/create", () =>
            import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/user/UserCreate")
          ).name("manager.user_create");
          Route.view("/update/:id", () =>
            import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/user/UserUpdate")
          ).name("manager.user_update");
        });
        Route.view("/company_user_create/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/subUser/SubUserCreate")
        ).name("manager.sub_user_create");

        Route.view("/company_user_create/:company_id/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/subUser/SubUserUpdate")
        ).name("manager.sub_user_update");

        /*---------------------------------------------------------------------------------------------------------------
        |                                               Fornecedor                                                      |
        ---------------------------------------------------------------------------------------------------------------*/
        Route.view("/supplier", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/supplier/SupplierList")
        ).name("manager.supplier");

        Route.view("/supplier/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/supplier/SupplierCreate")
        ).name("manager.supplier_create");

        Route.view("/supplier/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/supplier/SupplierUpdate")
        ).name("manager.supplier_update");

        /*________________________________________________________________________________________________________
            Embarcador
           ________________________________________________________________________________________________________*/
        Route.view("/shipper", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/shippers/ShipperList")
        ).name("manager.shipper");

        Route.view("/shipper/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/shippers/ShipperCreate")
        ).name("manager.shipper_create");

        Route.view("/shipper/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/shippers/ShipperUpdate")
        ).name("manager.shipper_update");

        /*________________________________________________________________________________________________________
          Finance Manager
          ________________________________________________________________________________________________________*/
        Route.view("/finance_manager", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/financeManagers/FinanceManagerList")
        ).name("manager.finance_manager");

        Route.view("/finance_manager/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/financeManagers/FinanceManagerCreate")
        ).name("manager.finance_manager_create");

        Route.view("/finance_manager/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/financeManagers/FinanceManagerUpdate")
        ).name("manager.finance_manager_update");

        /*________________________________________________________________________________________________________
         Transportadora
         ________________________________________________________________________________________________________*/
        Route.view("/transporter", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/transporters/TransporterList")
        ).name("manager.transporter");

        Route.view("/transporter/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/transporters/TransporterCreate")
        ).name("manager.transporter_create");

        Route.view("/transporter/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/transporters/TransporterUpdate")
        ).name("manager.transporter_update");


        /*________________________________________________________________________________________________________
          Gerenciadora de risco
          ________________________________________________________________________________________________________*/
        Route.view("/risk_manager", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/riskManagers/RiskManagerList")
        ).name("manager.risk_manager");

        Route.view("/risk_manager/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/riskManagers/RiskManagerCreate")
        ).name("manager.risk_manager_create");

        Route.view("/risk_manager/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/riskManagers/RiskManagerUpdate")
        ).name("manager.risk_manager_update");

        /*________________________________________________________________________________________________________
          Four Pl
          ________________________________________________________________________________________________________*/
        Route.view("/four_pl", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/fourPls/FourPlList")
        ).name("manager.four_pl");

        Route.view("/four_pl/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/fourPls/FourPlCreate")
        ).name("manager.four_pl_create");

        Route.view("/four_pl/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/fourPls/FourPlUpdate")
        ).name("manager.four_pl_update");

        /*________________________________________________________________________________________________________
          Auditor
          ________________________________________________________________________________________________________*/
        Route.view("/auditor", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/auditores/AuditorList")
        ).name("manager.auditor");

        Route.view("/auditor/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/auditores/AuditorCreate")
        ).name("manager.auditor_create");

        Route.view("/auditor/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/auditores/AuditorUpdate")
        ).name("manager.auditor_update");


        Route.view("/broker", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/brokers/BrokerList")
        ).name("manager.broker");

        Route.view("/broker/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/brokers/BrokerCreate")
        ).name("manager.broker_create");

        Route.view("/broker/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/brokers/BrokerUpdate")
        ).name("manager.broker_update");

        Route.view("/invoice/upload", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/invoice/InvoiceUpload")
        ).name("manager.invoice_upload")

        Route.view("/fintech", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/fintechs/FintechList")
        ).name("manager.fintech");

        Route.view("/fintech/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/fintechs/FintechCreate")
        ).name("manager.fintech_create");

        Route.view("/fintech/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/fintechs/FintechUpdate")
        ).name("manager.fintech_update");

        Route.view("/customer", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/customers/CustomerList")
        ).name("manager.customer");

        Route.view("/customer/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/customers/CustomerCreate")
        ).name("manager.customer_create");

        Route.view("/customer/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/users/customers/CustomerUpdate")
        ).name("manager.customer_update");
      });

      Route.view("/order", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrderList")
      ).name("manager.order");

      Route.view("/fob_order", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/fobOrder/FobOrder")
      ).name("manager.fob_order");

      Route.view("order/occurrences", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/Occurrence")
      ).name("manager.order_occurrences");

      Route.view("/orders_documents", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrdersDocuments")
      ).name("manager.orders_documents");

      Route.view("/exports", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/Exports")
      ).name("manager.orders_exports");

      Route.view("/order/create", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrderCreate")
      ).name("manager.order_create");

      Route.view("/order/update/:id", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrderUpdate")
      ).name("manager.order_update");

      Route.view("order/canceled", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrderCanceledList")
      ).name("manager.order_canceled");
      Route.view("order/canceled/:id", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrderCanceledDetails")
      ).name("manager.order_canceled_details");

      Route.view("/simulation", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/SimulationIntegra")
      ).name("manager.order_simulation");


      Route.view("/shipping_request_quote", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/ShippingRequestQuote")
      ).name("manager.order_shipping_request_quote");

      Route.view("/import_cte", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/components/ImportCte/CteImport")
      ).name("manager.import_cte");

      Route.view("/not_imported_files", () =>
        import(/* webpackChunkName: "manager" */ "@/resources/components/InvoiceFiles/NotImportedFilesList")
      ).name("manager.not_imported_files");

      Route.group({prefix: "driver"}, () => {

        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/driver/DriverList")
        ).name("manager.driver");

        Route.view("/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/driver/DriverCreate")
        ).name("manager.driver_create");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/driver/DriverUpdate")
        ).name("manager.driver_update");
      });

      Route.group({prefix: "vehicle"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/vehicle/VehicleList")
        ).name("manager.vehicle");

        Route.view("/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/vehicle/VehicleCreate")
        ).name("manager.vehicle_create");

        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/vehicle/VehicleUpdate")
        ).name("manager.vehicle_update");
      });

      /* --------------------------------------------------------------------------------------------------------------
      |                                             PURCHASE ORDER                                                    |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "purchase_order"}, () => {
        Route.view("/board", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/purchaseOrder/PurchaseOrderBoard")
        ).name("manager.purchase_order_board")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value]
            }
          });

        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/purchaseOrder/PurchaseOrderList")
        ).name("manager.purchase_order")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value, userPermission.INTEGRA_MANAGER__FINANCIER.value, userPermission.INTEGRA_MANAGER__FINANCIER_BASIC.value]
            }
          });

        Route.view("/details/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/purchaseOrder/PurchaseOrderDetails")
        ).name("manager.purchase_order_details")
          .options({
            meta: {
              visibilityPermission: [userPermission.INTEGRA_MANAGER__OWNER.value, userPermission.INTEGRA_MANAGER__ADMIN.value, userPermission.INTEGRA_MANAGER__FINANCIER.value, userPermission.INTEGRA_MANAGER__FINANCIER_BASIC.value]
            }
          });
      });

      Route.group({prefix: "export"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/export/OrderExport")
        ).name("manager.order_export");
        Route.view("/reports", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/export/OrderReport")
        ).name("manager.order_reports");

        Route.view("/requests", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/export/RequestExportView")
        ).name("manager.request_export");
        Route.view("/requests/reports", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/export/RequestReportView")
        ).name("manager.request_reports");

        Route.view("/orders_documents", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/export/OrdersDocumentsExport")
        ).name("manager.orders_documents_export");
        Route.view("/transporters", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/export/TransportersExport")
        ).name("manager.transporters_export");
      });

      Route.group({prefix: "canhoto"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/invoice/CanhotoList")
        ).name("manager.canhoto")
      });

      Route.group({prefix: "nf_files"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/invoice/NfList")
        ).name("manager.nf_files")
      });

      Route.group({prefix: "address"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/address/AddressAliasList")
        ).name("manager.address_alias")
        Route.view("/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/address/AddressAliasCreate")
        ).name("manager.address_alias_create")
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/address/AddressAliasUpdate")
        ).name("manager.address_alias_update")
      });

      /*---------------------------------------------------------------------------------------------------------------
                                                QUOTES                                                       |
       ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "quotes"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/order/OrderQuotes")
        ).name("manager.order_quotes");
        Route.view("/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/manager/order/QuoteDetails")
        ).name("manager.order_quotes_details");
        Route.view("/transporters/:id", () =>
          import(/* webpackChunkName: "v" */ "@/resources/views/logistic_manager/manager/order/QuoteDetailsTransporters")
        ).name("manager.order_quotes_details_transporters");
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               BILLING                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "billing"}, () => {
        Route.view("/opened", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/billing/BillingOpenedManager.vue")
        ).name("manager.billing.opened");
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/billing/BillingList.vue")
        ).name("manager.billing");
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               REQUEST FILES                                                   |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "request_files"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/requestFile/RequestFile.vue")
        ).name("manager.request_files");
      });
      /*---------------------------------------------------------------------------------------------------------------
      |                                               REQUEST                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "request"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/request/Request.vue")
        ).name("manager.request");
      });

      /*---------------------------------------------------------------------------------------------------------------
      |                                               ROAD MAP                                                       |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "road_map"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/roadMap/RoadMap.vue")
        ).name("manager.road_map");
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/roadMap/RoadMapUpdate.vue")
        ).name("manager.road_map_update");
      });


      Route.group({prefix: "marine"}, () => {
        Route.view("/list", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/marine/list")
        ).name("manager.marine");

        Route.view("/dashboard", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/marine/dashboard")
        ).name("manager.marine_dashboard");

        Route.view("/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/marine/form")
        ).name("manager.marine_form");

        Route.view("/control_tower", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/marine/ControlTower")
        ).name("manager.marine_control_tower");

        Route.view("/containers", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/marine/listContainer")
        ).name("manager.containers");

        Route.view("/containers_control_tower", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/marine/ContainerControlTower")
        ).name("manager.container_control_tower");

      });
      /*---------------------------------------------------------------------------------------------------------------
      |                                               Box                                                             |
      ---------------------------------------------------------------------------------------------------------------*/
      Route.group({prefix: "box"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/boxes/BoxList.vue")
        ).name("manager.box");
        Route.view("/create", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/boxes/BoxCreate.vue")
        ).name("manager.box_create");
        Route.view("/update", () =>
          import(/* webpackChunkName: "manager" */ "@/resources/views/logistic_manager/manager/boxes/BoxUpdate.vue")
        ).name("manager.box_update");
      });

    });

  });
});

export default Route.all();
